import { Injectable, signal, WritableSignal, ElementRef } from '@angular/core';
import { DomPortal, Portal } from '@angular/cdk/portal';
@Injectable({
  providedIn: 'root',
})
export class FloatingTrackService {
  portalContent: WritableSignal<Portal<any>[]> = signal([]);
  constructor() {}

  setFloatingTrackPortalContent(portal: Portal<any>) {
    this.portalContent.update(portals => [...portals, portal]);
  }

  clearFloatingTrackPortalContent() {
    this.portalContent.set([]);
  }

  addPortalContentFromDom(domElement: ElementRef) {
    this.setFloatingTrackPortalContent(new DomPortal(domElement));
  }

  removePortalContentFromDom(domElement: ElementRef) {
    this.portalContent.update(portals => {
      return portals.filter(portal => portal instanceof DomPortal && portal.element === domElement);
    });
  }
}
